// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import lgnBg from "../../Assets/Login/bgcolor.jpg";
// import logo from "../../Assets/Logos/logov.png";
// import axios from "axios";

// const Register = () => {
//   const navigate = useNavigate();

//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     password: "",
//   });
//   const showToast = (msg, type = "error") => {
//     toast[type](msg, {
//       position: "top-center",
//       autoClose: type === "error" ? 3000 : 2000,
//       hideProgressBar: false,
//       closeOnClick: true,
//       pauseOnHover: true,
//       draggable: true,
//       theme: "colored",
//     });
//   };

//   const [errors, setErrors] = useState({});

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));

//     if (name === "phone") {
//       if (!/^\d{0,10}$/.test(value)) return;
//       if (!/^\d{10}$/.test(value)) {
//         setErrors((prev) => ({
//           ...prev,
//           phone: "Enter 10-digit phone number",
//         }));
//       } else {
//         setErrors((prev) => ({ ...prev, phone: "" }));
//       }
//     }
//   };

//   const validate = () => {
//     const newErrors = {};
//     if (!form.name.trim()) newErrors.name = "Full Name is required";
//     if (!form.email.includes("@")) newErrors.email = "Invalid email address";
//     if (!/^\d{10}$/.test(form.phone))
//       newErrors.phone = "Enter 10-digit phone number";
//     if (form.password.length < 6)
//       newErrors.password = "Password must be at least 6 characters";
//     return newErrors;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Validate before submit
//     const validationErrors = validate();
//     setErrors(validationErrors);
//     if (Object.keys(validationErrors).length > 0) {
//       return;
//     }

//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}/users/register`,
//         form
//       );
//       if (response.data && response.data.token && response.data.user) {
//         localStorage.setItem("token", response.data.token);
//         localStorage.setItem("user", JSON.stringify(response.data.user));
//         toast.success("Registration successful! You are now logged in.", {
//           position: "top-center",
//         });
//         navigate("/");
//       } else {
//         showToast(response.data.message || "Registration failed");
//       }
//     } catch (error) {
//       console.error("Registration error:", error);
//       showToast("Registration failed");
//     }
//   };

//   return (
//     <div
//       className="w-full min-h-screen grid place-items-center bg-cover bg-center"
//       style={{ backgroundImage: `url(${lgnBg})` }}
//     >
//       <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-md">
//         <div className="flex justify-center mb-6">
//           <img src={logo} alt="logo" className="w-15 h-15" />
//         </div>

//         <h2 className="text-2xl font-semibold text-center mb-1">
//           Create an account
//         </h2>
//         <p className="text-gray-500 text-center mb-6">
//           Enter your details and join us
//         </p>

//         <form onSubmit={handleSubmit} className="space-y-4">
//           <div>
//             <input
//               type="text"
//               name="name"
//               placeholder="Full Name"
//               value={form.name}
//               onChange={handleChange}
//               className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${
//                 errors.name
//                   ? "border-red-500 focus:ring-red-400"
//                   : "focus:ring-blue-400"
//               }`}
//             />
//             {errors.name && (
//               <p className="text-red-500 text-sm">{errors.name}</p>
//             )}
//           </div>

//           <div>
//             <input
//               type="email"
//               name="email"
//               placeholder="Email Id"
//               value={form.email}
//               onChange={handleChange}
//               className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${
//                 errors.email
//                   ? "border-red-500 focus:ring-red-400"
//                   : "focus:ring-blue-400"
//               }`}
//             />
//             {errors.email && (
//               <p className="text-red-500 text-sm">{errors.email}</p>
//             )}
//           </div>

//           <div>
//             <input
//               type="text"
//               name="phone"
//               placeholder="Phone Number"
//               value={form.phone}
//               onChange={handleChange}
//               className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${
//                 errors.phone
//                   ? "border-red-500 focus:ring-red-400"
//                   : "focus:ring-blue-400"
//               }`}
//             />
//             {errors.phone && (
//               <p className="text-red-500 text-sm">{errors.phone}</p>
//             )}
//           </div>

//           <div>
//             <input
//               type="password"
//               name="password"
//               placeholder="Password"
//               value={form.password}
//               onChange={handleChange}
//               className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${
//                 errors.password
//                   ? "border-red-500 focus:ring-red-400"
//                   : "focus:ring-blue-400"
//               }`}
//             />
//             {errors.password && (
//               <p className="text-red-500 text-sm">{errors.password}</p>
//             )}
//           </div>

//           <button
//             type="submit"
//             className="w-full bg-primary text-white py-2 rounded-md hover:bg-btnHover transition duration-200"
//           >
//             Create Account
//           </button>
//         </form>

//         <div className="text-center mt-4">
//           <span className="text-gray-600">Already have an account? </span>
//           <button
//             onClick={() => navigate("/login")}
//             className="text-blue-600 hover:underline"
//           >
//             Log In
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Register;

import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Formik, Form, Field, ErrorMessage } from "formik";
import axios from "axios";
import lgnBg from "../../Assets/Login/bgcolor.jpg";
import logo from "../../Assets/Logos/logov.png";
import { registerValidationSchema } from "../../Validations/registerValidation";

const Register = () => {
  const navigate = useNavigate();
  const initialValues = {
    name: "",
    email: "",
    phone: "",
    password: "",
  };

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/users/register`,
        values
      );
      if (response.data && response.data.token && response.data.user) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        toast.success("Registration successful! You are now logged in.");
        navigate("/");
      } else {
        toast.error(response.data.message || "Registration failed",);
      }
    } catch (error) {
      // console.error("Registration error:", error);
      toast.error("User already exists",);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="w-full min-h-screen grid place-items-center bg-cover bg-center"
      style={{ backgroundImage: `url(${lgnBg})` }}
    >
      <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-md">
        <div className="flex justify-center mb-6">
          <img src={logo} alt="logo" className="w-15 h-15" />
        </div>

        <h2 className="text-2xl font-semibold text-center mb-1">
          Create an account
        </h2>
        <p className="text-gray-500 text-center mb-6">
          Enter your details and join us
        </p>

        <Formik
          initialValues={initialValues}
          validationSchema={registerValidationSchema}
          onSubmit={onSubmit}
        >
          {({ errors, touched, isSubmitting }) => (
            <Form className="space-y-4">
              <div>
                <Field
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                    errors.name && touched.name
                      ? "border-red-500 focus:ring-red-400"
                      : "focus:ring-blue-400"
                  }`}
                />
                <ErrorMessage
                  name="name"
                  component="div"
                  className="text-red-500 text-sm"
                />
              </div>

              <div>
                <Field
                  type="email"
                  name="email"
                  placeholder="Email Id"
                  className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                    errors.email && touched.email
                      ? "border-red-500 focus:ring-red-400"
                      : "focus:ring-blue-400"
                  }`}
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-red-500 text-sm"
                />
              </div>

              <div>
                <Field
                  type="text"
                  name="phone"
                  placeholder="Phone Number"
                  className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                    errors.phone && touched.phone
                      ? "border-red-500 focus:ring-red-400"
                      : "focus:ring-blue-400"
                  }`}
                />
                <ErrorMessage
                  name="phone"
                  component="div"
                  className="text-red-500 text-sm"
                />
              </div>

              <div>
                <Field
                  type="password"
                  name="password"
                  placeholder="Password"
                  className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                    errors.password && touched.password
                      ? "border-red-500 focus:ring-red-400"
                      : "focus:ring-blue-400"
                  }`}
                />
                <ErrorMessage
                  name="password"
                  component="div"
                  className="text-red-500 text-sm"
                />
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-primary text-white py-2 rounded-md hover:bg-btnHover transition duration-200"
              >
                {isSubmitting ? "Creating..." : "Create Account"}
              </button>
            </Form>
          )}
        </Formik>

        <div className="text-center mt-4">
          <span className="text-gray-600">Already have an account? </span>
          <button
            onClick={() => navigate("/login")}
            className="text-blue-600 hover:underline"
          >
            Log In
          </button>
        </div>
      </div>
    </div>
  );
};

export default Register;
